// Using import() would be ideal, but this ERB-generated JSON is loaded through require.
const RailsExportedConfig = require('./rails_constants.json.erb')
export default RailsExportedConfig
